import React from 'react';
import EditorialLayout from '@/components/editorial/EditorialLayout';
import { AnalyticsDashboard } from '@/components/analytics/AnalyticsDashboard';

const AnalyticsPage: React.FC = () => {
  return (
    <EditorialLayout>
      <AnalyticsDashboard />
    </EditorialLayout>
  );
};

export default AnalyticsPage;